import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import Select from 'react-select';

import { getAll } from '../../../../../../_actions/doctor.actions.js';

export default function ProviderOptions({ form, providerChanged }) {
  const providers = useSelector(state => state.doctor.collection);
  const [providerSelected, setProviderSelected] = useState(form.doctor.id);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAll());
  }, [dispatch]);

  if (providers.length === 0) {
    return <Spinner animation="border" role="status">
      <span className="sr-only">Loading...</span>
    </Spinner>
  }

  const providerOptions = providers.map((doctor) => {
    let name = `${doctor.firstName} ${doctor.lastName}`;
    name = (doctor.userType.prefix) ? `${doctor.userType.prefix} ${name}` : name;
    name = (doctor.userType.suffix) ? `${name} ${doctor.userType.suffix}` : name;

    return { value: doctor.id, label: name };
  });

  const selectedOption = providerOptions.find((provider) => {
    return provider.value === providerSelected;
  });

  return <Select
    options={providerOptions}
    onChange={(selected) => {
      providerChanged(selected.value);
      setProviderSelected(selected.value);
    }}
    value={selectedOption || ''}
  />
}